// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_UpdateOrigemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/origens/updateOrigem
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Origens_UpdateOrigemResponseDados = null;

export type Origens_UpdateOrigemResponse = ApiResponse<Origens_UpdateOrigemResponseDados>;

registerResponseContract('Origens_UpdateOrigemResponse', {})
